import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material';
import { Content, Event, User } from '../../models';
import { AuthenticationService, ContentService, SocketService } from '../../services';

@Component({
  selector: 'export-content',
  templateUrl: 'export-content.snack.html',
})
export class ExportContentSnack implements OnInit {
  public user: User;
  public export = {
    isReady: false,
    total: 0,
    processed: 0,
  };
  public timer = null;
  private zipName: string;

  constructor(
    private authService: AuthenticationService,
    private socketService: SocketService,
    private contentService: ContentService,
    private ref: ChangeDetectorRef,
    @Inject(MAT_SNACK_BAR_DATA) public content: Content) { }

  public ngOnInit() {
    this.user = this.authService.getCurrentUserCookie();
    this.export.isReady = false;
    this.export.processed = 0;
    this.contentService.export(this.content._id).subscribe((result: any) => {
      this.zipName = result.zipName;
    });

    // socket.io listeners
    this.socketService.onEvent(Event.ExportContentProgress).subscribe((data) => {
      if (this.user.username == data.username) {
        if (data.total) { this.export.total = data.total; }
        if (data.processed && data.processed <= this.export.total) { this.export.processed = data.processed; this.detectChanges(); }
        if (this.export.processed > this.export.total) { this.export.processed = this.export.total; }
      }
    });
    this.socketService.onEvent(Event.ExportContentReady).subscribe((data) => {
      this.export.isReady = data.progress == 100;
      this.detectChanges();
    });
  }

  public onDownload() {
    window.open('/export/' + this.user.username + '/' + this.zipName);
  }
  private detectChanges() {
    if (!this.timer) {
      this.timer = setTimeout(() => {
        this.timer = null;
        try {
          if (this.ref) {
            this.ref.detectChanges();
          }
        } catch (error) { }
      }, 100);
    }
  }
}
